import { JsonPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthStateService } from '../../core/services/auth-state.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'dnv-navigation',
  imports: [MatButton, TranslatePipe, MatIcon, JsonPipe],
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {
  loading = false;
  error = '';

  protected authService = inject(AuthService);
  protected authStateService = inject(AuthStateService);
  private snackBar = inject(MatSnackBar);

  public async login() {
    this.loading = true;
    try {
      await this.authService.login();
      this.loading = false;
    } catch (error: any) {
      this.loading = false;
      this.snackBar.open(error.message || 'Google Sign-in failed', 'Dismiss', {
        duration: 3000,
      });
      this.error = error.message || 'Google Sign-in failed';
    }
  }

  public async logout() {
    try {
      this.loading = true;
      await this.authService.logout();
      this.loading = false;
      this.snackBar.open('Logged out successfully', 'Dismiss', {
        duration: 3000,
      });
    } catch (error: any) {
      this.loading = false;
      this.snackBar.open(error.message || 'Logout failed', 'Dismiss', {
        duration: 3000,
      });
      this.error = error.message || 'Logout failed';
    }
  }
}
